import React, { useMemo } from "react";
import { ReturnCompleteSelect } from "../components/functions/ReturnCompleteSelect";
import { SignleOrMultiSelector } from "../components/functions/SignleOrMultiSelector";

const useLogicMechanismSelect = (
  onChange,
  isSingle,
  UiValue,
  SelectableDataArray,
  CompleteOutPut
) => {
  const memoDataArray = useMemo(
    () => SelectableDataArray,
    [JSON.stringify(SelectableDataArray)]
  );
  React.useEffect(() => {
    if (onChange) {
      if (CompleteOutPut) {
        onChange(ReturnCompleteSelect(SelectableDataArray, UiValue));
      } else {
        SignleOrMultiSelector(isSingle, onChange, UiValue, SelectableDataArray);
      }
    }
  }, [UiValue, memoDataArray]);
};

export default useLogicMechanismSelect;
